import type { ReactNode } from "react";
import { Toaster } from "@/components/ui/sonner";
import Footer from "@/pages/Footer";
import Navigation from "@/pages/Navigation";

export function Layout({ children }: { children: ReactNode }) {
	return (
		<div className="min-h-screen flex flex-col">
			<Toaster />
			<Navigation />
			<div className="flex-1">{children}</div>
			<Footer />
		</div>
	);
}
